module.exports = __webpack_public_path__ + "public/images/slider/ferdman-circle.7dfc1f5886c78cfdefe243eab72acd24.png";